import { render, staticRenderFns } from "./FizicalCard.vue?vue&type=template&id=d25c1802&"
import script from "./FizicalCard.vue?vue&type=script&lang=js&"
export * from "./FizicalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports